import { module as BaseModule } from "modujs"
import { load } from "recaptcha-v3"

export default class extends BaseModule {
  init() {
    this.submit = this.el.querySelector("[data-form-submit]")
    this.notice = this.el.querySelector("[data-form-notice]")
    this.form = this.el.querySelector("[data-form]")
    this.action = this.el.getAttribute("data-form-action")
    this.submitIcon = this.el.querySelector("[data-form-submit-icon]")
    this.submitIconLoading = this.el.querySelector("[data-form-submit-icon-loading]")

    if (!this.action) {
      return
    }

    this.listeners()
  }


  listeners() {
    this.el.addEventListener("submit", this.onSubmit.bind(this))
  }


  showError(message) {
    this.notice.classList.remove("hidden")
    this.notice.innerHTML = message
    this.notice.style.borderColor = "#f87171" // red-400
    this.notice.style.backgroundColor = "#fef2f2" // red-50
  }

  async onSubmit(e) {
    try {
      e.preventDefault()
      console.log("onSubmit")

      if (this.isSent || this.isSending) return
      this.notice.classList.add("hidden")
      this.submitIcon.classList.add("hidden")
      this.submitIconLoading.classList.remove("hidden")
      this.isSending = true
      this.submit.innerHTML = "Sending.."

      const recaptcha = await load("6Ld-f-grAAAAAIaQV1jchwSpm1HXGLZoqsoKqaCj")
      const token = await recaptcha.execute("newsletter")

      await this.sendFormData({
        token
      })
    } catch (error) {
      console.log(error)
      this.showError("An error occurred. Please try again.")
      this.submit.innerHTML = "Send request"
      this.isSending = false
    }
  }

  async sendFormData(data) {
    try {
      const request = await fetch("/wp-json/custom/v1/newsletter", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })

      const response = await request.json()
      const { status } = request
      const { message } = response

      if (status === 200) {
        this.submitForm()
      } else {
        this.showError(message)

        this.submitIcon.classList.remove("hidden")
        this.submitIconLoading.classList.add("hidden")
        this.isSending = false
      }
    } catch (error) {
      console.log(error)
      this.submitIcon.classList.remove("hidden")
      this.submitIconLoading.classList.add("hidden")
      this.showError("An error occurred. Please try again.")
      this.isSending = false
    }
  }

  async submitForm() {
    console.log("submitForm")
    this.el.action = this.action
    this.el.submit()
  }

  async submitFormBis() {
    try {
        const formData = new FormData(this.el)
        const data = {}
        const formDataArray = Array.from(formData)
        formDataArray.forEach(([key, value]) => {
          data[key] = value
        })

        const request = await fetch(this.action, {
          method: "POST",
          body: JSON.stringify(data),
        })
  
        // Check if response is JSON
        const contentType = request.headers.get('content-type')
        if (contentType && contentType.includes('application/json')) {
          const response = await request.json()
          const { status } = request
          const { message } = response

          console.log(status, message)
        } else {
          // Handle non-JSON response (likely HTML)
          const responseText = await request.text()
          console.log('Non-JSON response received:', responseText.substring(0, 100) + '...')
        }

        this.onSuccess()
        this.isSent = true
        this.isSending = false

    } catch (error) {
      console.log(error)
      this.showError("An error occurred. Please try again.")
      this.submitIcon.classList.remove("hidden")
      this.submitIconLoading.classList.add("hidden")
      this.isSending = false
    }
  }

  onSuccess() {
    this.form.classList.add("hidden")
    this.submit.classList.remove("hidden")
    this.submit.innerHTML = "Please check your email for a confirmation."
    this.submit.style.backgroundColor = "#10b981" // green-500
    this.submit.style.color = "white"
  }
}
